export default __webpack_public_path__ + "static/map/img/def_lines.51cdaaf.png";